export function elapsedStart(callback) {
    let start;
    const animate = (timestamp) => {
        if (start === undefined)
            start = timestamp;
        const elapsed = timestamp - start;

        if (elapsed < 1) {
            requestAnimationFrame((t) => animate(t));

        } else {
            callback?.();
        }
    }

    requestAnimationFrame(animate);
}

export function getCSSVal(element, property) {
  const styles = window.getComputedStyle(element);
  return styles[property];
}

export function getInnerWidth(element) {
  const styles = window.getComputedStyle(element);
  const p = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
  return element.offsetWidth - p;
}

export function debounce(callback, timing = 250) {
  let timeout = null;

  return (...args) => {
    window.clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(null, args), timing);
  };
}

export function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

export function getRandomInt(min, max) {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);

  return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
}

export function getRandomIntInclusive(min, max) {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);

  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled); // The maximum is inclusive and the minimum is inclusive
}

export function strRemoveSpaces(str = null) {
  if (!str) return "";

  if (`${str}`.length === 1) {
      if (str === " ")
          return ""
      return `${str}`.toLowerCase();
  }

  return `${str}`.trim().split(" ").join("");
}

export function strRemoveDiacritics(str = null) {
  if (!str) return;

  return str.normalize("NFD").replace(/[\u0300-\u036f'’]/g, "");
}

export function arrShuffle(arr = []) {
  let shuffle = [...arr];

  for (let i = shuffle.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffle[i], shuffle[j]] = [shuffle[j], shuffle[i]];
  }

  return shuffle;
}

export function arrGetRandomValue(arr = []) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function getCommonValsBetweenTwoArrays(arr1 = [], arr2 = []) {
  if (!(arr1.length > 0 && arr2.length > 0)) return [];

  const min = arr1.length > arr2.length ? arr2 : arr1;
  const max = arr1.length > arr2.length ? arr1 : arr2;
  const oMin = {},
    oMax = {};
  const arr = [];

  min.forEach((val) => (oMin[`val-${val}`] = val));
  max.forEach((val) => (oMax[`val-${val}`] = val));

  for (const [key, value] of Object.entries(oMin)) {
    if (oMax.hasOwnProperty(key)) arr.push(value);
  }

  return arr;
}

export function getAspectRatio(width, height) {
  return width / height;
}

export function getCookieByName(name) {
  if (!document.cookie.includes(name)) return null;

  const cookies = document.cookie.split(";").map((c) => c.trim());
  return cookies.find((c) => c.includes(name).split("="))[1];
}

export function getQueryStringData() {
  const data = {};

  if (!location.href.includes("?")) return data;

  if (location.href.includes("&")) {
    location.href
      .slice(location.href.indexOf("?") + 1, location.href.length)
      .split("&")
      .forEach((q) => {
        const [key, value] = q.split("=");
        if (!(key.length > 0 && value.length > 0)) return;
        data[key] = value.split("+");
      });
  } else {
    const [key, value] = location.href
      .slice(location.href.indexOf("?") + 1, location.href.length)
      .split("=");

    if (!(key.length > 0 && value.length > 0)) return data;

    data[key] = value.split("+");
  }

  delete data[location.href];

  return data;
}

export function remToPx(cssVar) {  
  if (!cssVar) return;

  const styles = window.getComputedStyle(document.documentElement);
  return parseFloat(styles.getPropertyValue(cssVar)) * parseFloat(styles.getPropertyValue("font-size"));
}

export function pxToRem(pixels) {
  if (!pixels) return;

  const styles = window.getComputedStyle(document.documentElement);  
  return pixels / 16;
}

export function getCompStyleProp(cssProp, target) {
  if (!(cssProp && target)) return;

  const styles = window.getComputedStyle(target);
  return styles.getPropertyValue(cssProp);
}

export function getTranslateX(cssVal) {
  return new DOMMatrixReadOnly(cssVal).e;
}